import styled from 'styled-components';

import HelpQuestion from '@/components/atom/icon/search/HelpQuestion';

const SearchHospitalResultEmpty = () => {
  return (
    <Wrapper>
      <EmptyResultWrapper>
        <HelpQuestion />
        <EmptyResultTitle>찾으시는 병원이 없어요</EmptyResultTitle>
        <EmptyResultOffer>
          필터와 검색명을 확인하고
          <br />
          다시 검색해주세요.
        </EmptyResultOffer>
        <EmptyResultDescription>
          TIP. 띄어쓰기를 주의하고
          <br />
          주소를 &quot;시 / 군 / 구 / 동&quot;으로 검색해주세요!
          <br />
          <br />
          {'예시)'}
          <br />
          {'관악구신림동(X), 금천구 시흥사거리(X)'}
          <br />
          {'관악구 신림동(O) 금천구 시흥동(O)'}
        </EmptyResultDescription>
      </EmptyResultWrapper>
    </Wrapper>
  );
};

export default SearchHospitalResultEmpty;

const Wrapper = styled.div`
  display: flex;
  width: 100%;
  min-height: ${({ theme }) => `calc(100dvh - ${theme.size.appHeader.height})`};
  text-align: center;
  justify-content: center;
  padding-top: 80px;
`;

const EmptyResultWrapper = styled.div``;

const EmptyResultTitle = styled.div`
  ${({ theme }) => theme.typography.UI20SB};
  color: ${({ theme }) => theme.color.gray700};
  margin-top: 20px;
`;

const EmptyResultOffer = styled.div`
  ${({ theme }) => theme.typography.UI15R};
  color: ${({ theme }) => theme.color.gray400};
  margin: 8px 0;
`;
const EmptyResultDescription = styled.div`
  ${({ theme }) => theme.typography.UI12R};
  color: ${({ theme }) => theme.color.gray300};
`;
